export const HasuraRole = Object.freeze({
	ANON: 'anonymous',
});

export const HASURA_ROLE_HEADER = 'X-Hasura-Role';
